module.exports = __webpack_public_path__ + "static/media/buy_finish_service_rent_1.9f4425aa.jpg";